module.exports = __webpack_public_path__ + "img/cloneicon.7711cba2.svg";